export default __webpack_public_path__ + "static/media/share.bf356452.svg";